import React, { useEffect, useState, createElement } from 'react';
import { Flame, CheckCircle2, ShieldCheck, Zap, Lock, Clock, Sparkles, MessageSquare, AlertTriangle, BookOpen, Target, Gift, Frown } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
declare global {
  interface Window {
    fbq: any;
  }
}
export function ThankYouOfferPage() {
  // 15-minute countdown
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  useEffect(() => {
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('track', 'PageView');
    window.fbq('trackCustom', 'ThankYou-Offer-View');
    // Countdown
    const interval = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const formatTime = (s: number) => {
    const m = Math.floor(s / 60);
    const sec = s % 60;
    return `${m.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`;
  };
  return <div className="min-h-screen bg-[#0a0e1a] text-white font-sans selection:bg-amber-400 selection:text-black" data-id="element-5088" data-mp="1vu2hye9aqn4f">
      {/* Meta Pixel Noscript */}
      <noscript data-id="element-5089" data-mp="ydvougo73rju">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=PageView&noscript=1" alt="" data-id="element-5090" data-mp="yeevv2cb4vj3" />
      </noscript>

      {/* Urgency Top Bar */}
      <div className="sticky top-0 z-50 bg-gradient-to-r from-amber-500 via-amber-400 to-amber-500 text-black py-2.5 px-4 shadow-lg" data-id="element-5091" data-mp="vaza2xxcvpn6">
        <div className="max-w-5xl mx-auto flex items-center justify-center gap-2 md:gap-3 text-center" data-id="element-5092" data-mp="152lqr9sgqgxb">
          <Flame className="w-4 h-4 md:w-5 md:h-5 flex-shrink-0 animate-pulse" data-id="element-5093" data-mp="1038xa6736blr" />
          <p className="text-[11px] md:text-sm font-black uppercase tracking-wide" data-id="element-5094" data-mp="ce7w940l22qi">
            OFERTA EXCLUSIVA — EXPIRA EN{' '}
            <span className="font-mono bg-black text-amber-400 px-2 py-0.5 rounded ml-1 tabular-nums" data-id="element-5095" data-mp="7fwgydrir00w">
              {formatTime(timeLeft)}
            </span>
          </p>
        </div>
      </div>

      {/* Registration Incomplete Alert — keeps visitors on page */}
      <div className="bg-red-600 py-2 px-4" data-id="element-5096" data-mp="1xriyiiz1svbt">
        <div className="max-w-4xl mx-auto flex items-center justify-center gap-2 text-center" data-id="element-5097" data-mp="1xq7vildffrlr">
          <AlertTriangle className="w-3.5 h-3.5 md:w-4 md:h-4 text-yellow-300 flex-shrink-0 animate-pulse" data-id="element-5098" data-mp="1sro8ehn3k9rt" />
          <p className="text-white font-bold text-[11px] md:text-sm uppercase tracking-tight leading-tight" data-id="element-5099" data-mp="20adz2ry4pg1s">
            Tu registración al webinar no está completa aún
          </p>
        </div>
      </div>

      <main className="max-w-4xl mx-auto px-4 md:px-6 py-8 md:py-12 lg:py-16" data-id="element-5100" data-mp="1rcvdnmgkozpd">
        {/* Hero Section */}
        <section className="text-center mb-10 md:mb-14 lg:mb-16" data-id="element-5101" data-mp="1vd5opdj82gb3">
          <div className="inline-flex items-center gap-2 bg-amber-500/10 border border-amber-500/30 rounded-full px-4 py-1.5 mb-5 md:mb-6" data-id="element-5102" data-mp="2j3hx0pidqf27">
            <Sparkles className="w-3.5 h-3.5 text-amber-400" data-id="element-5103" data-mp="2o3nuwnf8sxsq" />
            <span className="text-amber-400 text-[11px] md:text-sm font-bold uppercase tracking-widest" data-id="element-5104" data-mp="2a9d9aeyjljqw">
              Solo durante los próximos 15 minutos
            </span>
          </div>

          <h1 className="text-[26px] md:text-4xl lg:text-5xl font-black leading-[1.15] tracking-tight mb-5 md:mb-6" data-id="element-5105" data-mp="3209mjgoilqep">
            Antes de Cerrar Esta Página...
            <br data-id="element-5106" data-mp="1j3ptr187stec" />
            <span className="text-amber-400" data-id="element-5107" data-mp="1j492brbz65fp">
              Lleva los 200 Mensajes EXACTOS
            </span>{' '}
            Que Mis Alumnos Están Usando Para Cerrar Clientes Locales —{' '}
            <span className="text-white underline decoration-amber-400 decoration-4 underline-offset-4" data-id="element-5108" data-mp="195a4l3sqzu7h">
              Por Solo $27
            </span>
          </h1>

          <div className="flex justify-center mb-6 md:mb-8" data-id="element-5109" data-mp="1561afxtspube">
            <img src="https://cdn.magicpatterns.com/uploads/4n1XFjTikJYFAFB3YJ15PL/Libro_200_Mensajes.png" alt="200 Mensajes de WhatsApp para Cerrar Clientes — mockup del libro" className="w-full max-w-lg md:max-w-2xl h-auto rounded-2xl shadow-[0_25px_70px_-15px_rgba(0,0,0,0.7)] ring-1 ring-white/10" data-id="element-5110" data-mp="21t5xryj3z3zi" />
          </div>

          <p className="text-base md:text-lg lg:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-5111" data-mp="1o2k9tvess3ur">
            El manual completo con{' '}
            <span className="text-white font-bold" data-id="element-5112" data-mp="2fu8gq2et3y67">
              200 mensajes WhatsApp listos para copiar y pegar
            </span>{' '}
            — organizados por nicho y situación — para que ejecutes desde el{' '}
            <span className="text-amber-400 font-bold" data-id="element-5113" data-mp="7bgq6uvb09fj">JUEVES</span> en cuanto
            termine el webinar.
          </p>
        </section>

        {/* Problem Section */}
        <section className="mb-10 md:mb-14" data-id="element-5114" data-mp="gavh1vfdum0k">
          <div className="bg-gradient-to-br from-red-950/40 to-[#0a0e1a] border border-red-500/20 rounded-2xl p-6 md:p-8 lg:p-10" data-id="element-5115" data-mp="gconpapzx68k">
            <div className="flex items-center gap-3 md:gap-4 mb-5" data-id="element-5116" data-mp="l8dplkphmz81">
              <div className="w-11 h-11 md:w-12 md:h-12 bg-red-500/10 border border-red-500/30 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-5117" data-mp="q7qeeazx6gd9">
                <Frown className="w-5 h-5 md:w-6 md:h-6 text-red-400" data-id="element-5118" data-mp="z24pe1df34qk" />
              </div>
              <h2 className="text-xl md:text-3xl font-black text-white leading-tight" data-id="element-5119" data-mp="140y3nw0j2zrs">
                El Problema Real
              </h2>
            </div>
            <div className="text-gray-300 text-base md:text-lg leading-relaxed space-y-4 md:pl-[60px]" data-id="element-5120" data-mp="1902cumngcxi4">
              <p data-id="element-5121" data-mp="35372bwr053pi">Mira, te soy directo:</p>
              <p data-id="element-5122" data-mp="30445gzl6e3sm">
                El jueves vas a salir del webinar emocionado. Vas a querer
                mandar tu primer mensaje. Vas a abrir WhatsApp...
              </p>
              <p data-id="element-5123" data-mp="3eujy2zfx8e0t">Y te vas a quedar mirando la pantalla en blanco pensando:</p>
              <p className="text-white italic border-l-2 border-amber-400 pl-4 my-5" data-id="element-5124" data-mp="3a0pfjzc1y53b">
                "¿Qué le escribo a este dentista? ¿Cómo abro la conversación sin
                sonar a vendedor desesperado? ¿Y si me ignora?"
              </p>
              <p data-id="element-5125" data-mp="1mqjkxp2yjpt">
                Eso le pasa al{' '}
                <span className="text-red-400 font-bold" data-id="element-5126" data-mp="1k4ct0a0k88n">80%</span> de los que
                toman acción después de un webinar. Y por eso al{' '}
                <span className="text-red-400 font-bold" data-id="element-5127" data-mp="23cs88ngf1rdv">
                  80% NO les funciona.
                </span>
              </p>
              <p className="text-white font-bold" data-id="element-5128" data-mp="1yg1wgcbn9hy9">
                No es que el sistema sea malo. Es que NO tienen el copy
                correcto.
              </p>
            </div>
          </div>
        </section>

        {/* Solution Section */}
        <section className="mb-10 md:mb-14" data-id="element-5129" data-mp="476f2xee0pe6">
          <div className="bg-gradient-to-br from-amber-950/40 to-[#0a0e1a] border border-amber-500/30 rounded-2xl p-6 md:p-8 lg:p-10" data-id="element-5130" data-mp="463nen98qix7">
            <div className="flex items-center gap-3 md:gap-4 mb-5" data-id="element-5131" data-mp="3rbcjrn1keff6">
              <div className="w-11 h-11 md:w-12 md:h-12 bg-amber-500/10 border border-amber-500/30 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-5132" data-mp="3ra1gdoc179ol">
                <Zap className="w-5 h-5 md:w-6 md:h-6 text-amber-400" data-id="element-5133" data-mp="3hdyfelsx1h38" />
              </div>
              <h2 className="text-xl md:text-3xl font-black text-white leading-tight" data-id="element-5134" data-mp="3mbq5daa02t4s">
                La Solución
              </h2>
            </div>
            <div className="text-gray-300 text-base md:text-lg leading-relaxed space-y-4 md:pl-[60px]" data-id="element-5135" data-mp="1fmldm5m8vpbe">
              <p data-id="element-5136" data-mp="1kish7rr64oq6">Por eso compilé este manual:</p>
              <ul className="space-y-3" data-id="element-5137" data-mp="8bt3qkaee8fp">
                <li className="flex items-start gap-3" data-id="element-5138" data-mp="8aqf6j0jsi2y">
                  <div className="w-8 h-8 rounded-lg bg-amber-500/10 border border-amber-500/30 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-5139" data-mp="3c6pc7iu2m5b">
                    <MessageSquare className="w-4 h-4 text-amber-400" data-id="element-5140" data-mp="3uorkujlobqkm" />
                  </div>
                  <span className="pt-1" data-id="element-5141" data-mp="3ppx3lm3cua2m">
                    <span className="text-white font-bold" data-id="element-5142" data-mp="3kt6ph4b41oju">
                      200 mensajes EXACTOS
                    </span>
                    , palabra por palabra
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-5143" data-mp="3btb7ogn1uvau">
                  <div className="w-8 h-8 rounded-lg bg-amber-500/10 border border-amber-500/30 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-5144" data-mp="36t5egw14t0qn">
                    <Target className="w-4 h-4 text-amber-400" data-id="element-5145" data-mp="19zk9no9ypl9v" />
                  </div>
                  <span className="pt-1" data-id="element-5146" data-mp="152tud35zetpi">
                    Organizados por{' '}
                    <span className="text-white font-bold" data-id="element-5147" data-mp="1cm37n7hlzcju">6 nichos</span> (los
                    más rentables en USA)
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-5148" data-mp="1hi1swm7n4eg1">
                  <div className="w-8 h-8 rounded-lg bg-amber-500/10 border border-amber-500/30 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-5149" data-mp="1mcfnwnie4jk6">
                    <Zap className="w-4 h-4 text-amber-400" data-id="element-5150" data-mp="tmp88a1419ly" />
                  </div>
                  <span className="pt-1" data-id="element-5151" data-mp="totn1n0jrt10">
                    Y por{' '}
                    <span className="text-white font-bold" data-id="element-5152" data-mp="ylsg028h5txm">5 situaciones</span>{' '}
                    (primer contacto, follow-up, objeciones, cierre)
                  </span>
                </li>
              </ul>
              <p className="pt-2" data-id="element-5153" data-mp="18hn59g77en9d">Cada mensaje tiene:</p>
              <ul className="space-y-2" data-id="element-5154" data-mp="2eyqqg3pk4ujm">
                <li className="flex items-start gap-2" data-id="element-5155" data-mp="2f1whhohqy6hz">
                  <CheckCircle2 className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" data-id="element-5156" data-mp="2jxtwnrh9x6t6" />
                  <span data-id="element-5157" data-mp="2fr9rpkrpka6n">Cuándo usarlo</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-5158" data-mp="2js258q7m518q">
                  <CheckCircle2 className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" data-id="element-5159" data-mp="2jqinev6b6i4u" />
                  <span data-id="element-5160" data-mp="2ok3dm11nu7th">Variables editables ([NOMBRE], [CIUDAD], etc.)</span>
                </li>
                <li className="flex items-start gap-2" data-id="element-5161" data-mp="2tgk06qt7oe4g">
                  <CheckCircle2 className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" data-id="element-5162" data-mp="1wrm7rf8xosag" />
                  <span data-id="element-5163" data-mp="1wtysu19znirq">Tip de psicología detrás de por qué funciona</span>
                </li>
              </ul>
              <p className="text-white font-bold pt-3" data-id="element-5164" data-mp="25skbdwfgmxsi">
                Solo abres, eliges el mensaje correcto, reemplazas variables, y
                mandas.{' '}
                <span className="text-amber-400" data-id="element-5165" data-mp="2apapwfbm9lbt">10 segundos por mensaje.</span>
              </p>
            </div>
          </div>
        </section>

        {/* What's Included Section */}
        <section className="mb-10 md:mb-14" data-id="element-5166" data-mp="3m4zgdgo2x2hd">
          <div className="text-center mb-8 md:mb-10" data-id="element-5167" data-mp="1aixhqyum24jf">
            <span className="inline-block bg-cyan-500/10 text-cyan-400 border border-cyan-500/20 px-4 py-1.5 rounded-full text-[11px] md:text-sm font-bold tracking-widest uppercase mb-4" data-id="element-5168" data-mp="1aife3h5mco1h">
              Lo Que Incluye
            </span>
            <h2 className="text-2xl md:text-4xl font-black text-white leading-tight" data-id="element-5169" data-mp="vuavseahaej8">
              Todo Lo Que Recibes Hoy
            </h2>
          </div>

          {/* Niches */}
          <div className="bg-white/[0.03] border border-white/10 rounded-2xl p-6 md:p-8 mb-5" data-id="element-5170" data-mp="rqct5tly2llf">
            <div className="flex items-start gap-3 md:gap-4 mb-5" data-id="element-5171" data-mp="mvpawchjanfa">
              <div className="w-11 h-11 md:w-12 md:h-12 bg-amber-500/10 border border-amber-500/30 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-5172" data-mp="hvb5713enpkf">
                <BookOpen className="w-5 h-5 md:w-6 md:h-6 text-amber-400" data-id="element-5173" data-mp="2c8aszhhxvq2s" />
              </div>
              <h3 className="text-lg md:text-2xl font-black text-white leading-tight pt-1" data-id="element-5174" data-mp="279ppn97e4qa4">
                Los 6 Nichos Más Rentables{' '}
                <span className="text-amber-400 block md:inline" data-id="element-5175" data-mp="5jij0d41czrm">
                  (25 mensajes c/u)
                </span>
              </h3>
            </div>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-3 text-gray-300 text-sm md:text-base md:pl-[60px]" data-id="element-5176" data-mp="3rrs2jsr9q99l">
              {['Dentistas y clínicas médicas', 'Salones de belleza, barberías, spas', 'Restaurantes y bares', 'Abogados, contadores, notarios', 'Gimnasios y studios de fitness', 'Talleres mecánicos y servicios automotrices'].map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-5177" data-mp="t8jru1gs6cxf">
                  <CheckCircle2 className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" data-id="element-5178" data-mp="fav9b0a6rhvj" />
                  <span data-id="element-5179" data-mp="jb5q77zinsp6">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Situations */}
          <div className="bg-white/[0.03] border border-white/10 rounded-2xl p-6 md:p-8 mb-5" data-id="element-5180" data-mp="2zz9jlb9mdrw2">
            <div className="flex items-start gap-3 md:gap-4 mb-5" data-id="element-5181" data-mp="34265pbydc64r">
              <div className="w-11 h-11 md:w-12 md:h-12 bg-amber-500/10 border border-amber-500/30 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-5182" data-mp="2wiervyt1qmwp">
                <BookOpen className="w-5 h-5 md:w-6 md:h-6 text-amber-400" data-id="element-5183" data-mp="2risdhm1hf0mb" />
              </div>
              <h3 className="text-lg md:text-2xl font-black text-white leading-tight pt-1" data-id="element-5184" data-mp="36g2pqxly8aj3">
                Las 5 Situaciones Clave{' '}
                <span className="text-amber-400 block md:inline" data-id="element-5185" data-mp="2drx325bc4bgm">
                  (10 mensajes c/u)
                </span>
              </h3>
            </div>
            <ul className="space-y-3 text-gray-300 text-sm md:text-base md:pl-[60px]" data-id="element-5186" data-mp="28udr5c240aru">
              {[{
              title: 'Primer contacto cold',
              desc: 'cómo abrir sin sonar a spam'
            }, {
              title: 'Cuando no responden',
              desc: 'cómo hacer follow-up sin molestar'
            }, {
              title: 'Cuando piden precio en WhatsApp',
              desc: 'cómo pivotar a llamada'
            }, {
              title: 'Manejo de objeciones',
              desc: '"está caro", "ya tengo web", etc.'
            }, {
              title: 'Cierre y agendamiento',
              desc: 'cómo mover a llamada SIN perder al lead'
            }].map(item => <li key={item.title} className="flex items-start gap-2.5" data-id="element-5187" data-mp="12auhc0h8wyea">
                  <CheckCircle2 className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" data-id="element-5188" data-mp="172m6q7oo0y2u" />
                  <span data-id="element-5189" data-mp="1c1yvwz30eh8l">
                    <span className="text-white font-semibold" data-id="element-5190" data-mp="1c0npssm3cxeb">
                      {item.title}
                    </span>{' '}
                    <span className="text-gray-400" data-id="element-5191" data-mp="1h2mty4pnnycb">({item.desc})</span>
                  </span>
                </li>)}
            </ul>
          </div>

          {/* Bonuses */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5" data-id="element-5192" data-mp="1pzx41mqqlhfn">
            <div className="bg-gradient-to-br from-amber-500/10 to-amber-700/5 border border-amber-500/30 rounded-2xl p-5 md:p-7" data-id="element-5193" data-mp="3mua609r5j2ot">
              <div className="flex items-center gap-2.5 mb-3" data-id="element-5194" data-mp="3rt3f7pzeo7j6">
                <div className="w-9 h-9 rounded-lg bg-amber-500/15 border border-amber-500/30 flex items-center justify-center flex-shrink-0" data-id="element-5195" data-mp="3k9c26f1wqsc6">
                  <Gift className="w-4 h-4 text-amber-400" data-id="element-5196" data-mp="3fh10p7riqyhi" />
                </div>
                <span className="text-amber-400 font-black text-[11px] md:text-xs uppercase tracking-wider" data-id="element-5197" data-mp="3ajsjb9e72yhb">
                  Bonus #1
                </span>
              </div>
              <h4 className="text-white font-bold text-base md:text-lg mb-2 leading-snug" data-id="element-5198" data-mp="71hegsp9mgby">
                Las 5 Reglas de Oro del WhatsApp Marketing
              </h4>
              <p className="text-gray-400 text-sm" data-id="element-5199" data-mp="3t9gztxhaucd5">
                Sin esto, los 200 mensajes no funcionan.
              </p>
            </div>
            <div className="bg-gradient-to-br from-amber-500/10 to-amber-700/5 border border-amber-500/30 rounded-2xl p-5 md:p-7" data-id="element-5200" data-mp="3p7dmt4ezezpr">
              <div className="flex items-center gap-2.5 mb-3" data-id="element-5201" data-mp="2hshbfcy2ohoe">
                <div className="w-9 h-9 rounded-lg bg-amber-500/15 border border-amber-500/30 flex items-center justify-center flex-shrink-0" data-id="element-5202" data-mp="2ds75g0aa5r9j">
                  <Gift className="w-4 h-4 text-amber-400" data-id="element-5203" data-mp="2f8b20pqovz0g" />
                </div>
                <span className="text-amber-400 font-black text-[11px] md:text-xs uppercase tracking-wider" data-id="element-5204" data-mp="2k75xos9r9i1z">
                  Bonus #2
                </span>
              </div>
              <h4 className="text-white font-bold text-base md:text-lg mb-2 leading-snug" data-id="element-5205" data-mp="2a9hq31r1wg2e">
                Plantilla editable en Google Docs
              </h4>
              <p className="text-gray-400 text-sm" data-id="element-5206" data-mp="21awcll0frr8h">
                Para que personalices y guardes tus versiones favoritas.
              </p>
            </div>
          </div>
        </section>

        {/* Unified Value + CTA + Pricing Section */}
        <section className="mb-8" data-id="element-5207" data-mp="1rkumyosfq0rg">
          <div className="bg-gradient-to-br from-[#0f1729] to-[#0a0e1a] border-2 border-amber-500/40 rounded-2xl p-6 md:p-10 shadow-[0_0_50px_rgba(245,158,11,0.15)]" data-id="element-5208" data-mp="1dks6n6zrzfeb">
            {/* Value Anchor */}
            <div className="text-center" data-id="element-5209" data-mp="yy37j69fr48g">
              <h2 className="text-2xl md:text-4xl font-black text-white leading-tight mb-4 md:mb-5" data-id="element-5210" data-mp="yyw8trpml1j7">
                Valor Real vs Inversión Hoy
              </h2>
              <p className="text-gray-300 text-base md:text-lg leading-relaxed mb-6 max-w-2xl mx-auto" data-id="element-5211" data-mp="17yj92a6mc1ao">
                Si pagaras a un copywriter por crear estos 200 mensajes desde
                cero, te cobrarían entre{' '}
                <span className="text-white font-bold" data-id="element-5212" data-mp="1hvxj9s1y7tuj">
                  $50–$100 por mensaje.
                </span>
              </p>
              <div className="flex flex-col items-center gap-1" data-id="element-5213" data-mp="1cvrv4luw0ph7">
                <span className="text-gray-500 text-[11px] md:text-sm uppercase tracking-widest" data-id="element-5214" data-mp="1qnzenbx5ujxy">
                  Valor en el mercado
                </span>
                <span className="text-3xl md:text-5xl font-black text-gray-500 line-through decoration-red-500 decoration-2" data-id="element-5215" data-mp="20n724rxlzuys">
                  $10,000 – $20,000
                </span>
              </div>
              <p className="text-gray-400 text-sm md:text-base mt-5 max-w-xl mx-auto" data-id="element-5216" data-mp="33130ct64cco8">
                Se paga solo con el{' '}
                <span className="text-white font-bold" data-id="element-5217" data-mp="371d9uft4dl7u">PRIMER cliente</span> que
                cierres usando UNO solo de estos mensajes.
              </p>
            </div>

            {/* Divider */}
            <div className="my-7 md:my-8 border-t border-dashed border-amber-500/20" data-id="element-5218" data-mp="3gz9h2wixrw0o" />

            {/* Price summary */}
            <div className="text-center mb-7" data-id="element-5219" data-mp="2jen8lgolhuoa">
              <div className="flex justify-center mb-6" data-id="element-5220" data-mp="2obdmbxcxge6j">
                <img src="https://cdn.magicpatterns.com/uploads/6ftzgqwNdfAsRjM99tDYEx/Libro_200_Mensajes.png" alt="200 Mensajes de WhatsApp para Cerrar Clientes" className="w-full max-w-md md:max-w-xl h-auto rounded-xl shadow-[0_20px_60px_-10px_rgba(0,0,0,0.6)] ring-1 ring-white/10" data-id="element-5221" data-mp="2o9u5o5nd0148" />
              </div>
              <p className="text-amber-400 text-[11px] md:text-sm uppercase tracking-widest font-bold mb-2" data-id="element-5222" data-mp="20k84xdrc9du4">
                Hoy lo llevas por
              </p>
              <p className="text-6xl md:text-8xl font-black text-amber-400 mb-2 leading-none tabular-nums" data-id="element-5223" data-mp="1y0lbi1q1p9hk">
                $27{' '}
                <span className="text-lg md:text-2xl text-gray-500 font-medium align-top" data-id="element-5224" data-mp="1t0qjfuujadux">
                  USD
                </span>
              </p>
              <p className="text-amber-400 text-sm md:text-base font-semibold" data-id="element-5225" data-mp="1j5f71j6lliqc">
                Pago único · Sin suscripción
              </p>
            </div>

            {/* Main CTA Button */}
            <a href="https://www.fanbasis.com/agency-checkout/true-marketer/wKOVJ" target="_blank" rel="noopener noreferrer" className="group block w-full" onClick={() => {
            if (typeof window.fbq === 'function') {
              window.fbq('track', 'InitiateCheckout', {
                value: 27,
                currency: 'USD'
              });
            }
          }} data-id="element-5226" data-mp="1ac20hefm2ils">
              <button className="relative w-full bg-gradient-to-r from-amber-500 to-amber-400 hover:from-amber-400 hover:to-amber-300 text-[#0a0e1a] font-black text-sm md:text-xl uppercase tracking-tight py-5 md:py-6 px-4 md:px-6 rounded-xl shadow-[0_0_30px_rgba(245,158,11,0.4)] transition-all duration-300 transform hover:scale-[1.02] overflow-hidden" data-id="element-5227" data-mp="rcxy2oikrn33">
                <span className="relative z-10 flex items-center justify-center gap-2 md:gap-3 flex-wrap" data-id="element-5228" data-mp="33gtu2lx03gb1">
                  <MessageSquare className="w-5 h-5 md:w-6 md:h-6 flex-shrink-0" data-id="element-5229" data-mp="2yhyzyntl25bm" />
                  <span data-id="element-5230" data-mp="2thujuywl7clx">SÍ, QUIERO LOS 200 MENSAJES POR $27</span>
                </span>
                <div className="absolute top-0 left-[-100%] w-full h-full bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-[-25deg] group-hover:animate-shine" data-id="element-5231" data-mp="2oo9ufv927qyc" />
              </button>
            </a>

            {/* Microcopy */}
            <div className="mt-5 flex items-center justify-center gap-x-4 gap-y-2 flex-wrap text-[11px] md:text-sm text-gray-400" data-id="element-5232" data-mp="2aps7w0uw4ki0">
              <span className="flex items-center gap-1.5" data-id="element-5233" data-mp="25s07eig6jq27">
                <CheckCircle2 className="w-4 h-4 text-emerald-400" data-id="element-5234" data-mp="l8wmk3al20p8" />
                Descarga inmediata
              </span>
              <span className="flex items-center gap-1.5" data-id="element-5235" data-mp="q780oq7wuxd9">
                <CheckCircle2 className="w-4 h-4 text-emerald-400" data-id="element-5236" data-mp="q9u7uoqw3auy" />
                Garantía 7 días
              </span>
              <span className="flex items-center gap-1.5" data-id="element-5237" data-mp="z8fk625rptna">
                <CheckCircle2 className="w-4 h-4 text-emerald-400" data-id="element-5238" data-mp="z7wcde9u0lmz" />
                Pago seguro con tarjeta
              </span>
              <span className="flex items-center gap-1.5" data-id="element-5239" data-mp="7hj9n876k136">
                <CheckCircle2 className="w-4 h-4 text-emerald-400" data-id="element-5240" data-mp="7i1g0xnk3vot" />
                Acceso de por vida
              </span>
            </div>

            {/* Downsell link — right under the CTA so users don't miss the next step */}
            <div className="text-center mt-4" data-id="element-5241" data-mp="3fxbb3lt140n3">
              <Link to="/thank-you-downsale" className="text-white hover:text-gray-200 text-sm md:text-base underline underline-offset-4 transition-colors" data-id="element-5242" data-mp="3fwjqf60yznbl">
                No gracias, solo quiero ir al webinar →
              </Link>
            </div>

            {/* Guarantee Block */}
            <div className="mt-7 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center gap-4" data-id="element-5243" data-mp="m64tg7tt2fp8">
              <div className="w-14 h-14 md:w-16 md:h-16 bg-emerald-500/10 rounded-full flex items-center justify-center border border-emerald-500/20 flex-shrink-0" data-id="element-5244" data-mp="10sy2ivcqep8z">
                <ShieldCheck className="w-7 h-7 md:w-8 md:h-8 text-emerald-400" data-id="element-5245" data-mp="85c2ty6mk4re" />
              </div>
              <div className="text-center md:text-left" data-id="element-5246" data-mp="370pvel19e4y">
                <h4 className="text-white font-bold text-base md:text-lg mb-1" data-id="element-5247" data-mp="38bvzl1yaxz8">
                  Garantía Incondicional de 7 Días
                </h4>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-5248" data-mp="d4f5jbz4tyw7">
                  Si no encuentras valor en el manual, te devuelvo el 100% de tu
                  inversión. Sin preguntas.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Trust footer note */}
        <div className="text-center text-gray-600 text-xs md:text-sm pt-6 flex items-center justify-center gap-1.5" data-id="element-5249" data-mp="1w2jsenujtt08">
          <Clock className="w-4 h-4 flex-shrink-0" data-id="element-5250" data-mp="213r0yp4imw7y" />
          <span data-id="element-5251" data-mp="1m5otw4y9zsly">
            Esta oferta no estará disponible después de salir de esta página.
          </span>
        </div>
      </main>

      <Footer data-id="element-5252" data-mp="1r4s0vuxtg8wk" />
    </div>;
}